import { Toolbar, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { FaTimes } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import PropTypes from "prop-types";
import MenuList from "./MenuList";

const DrawerContent = ({
  mobileOpen,
  handleDrawerToggle,
  handleMenuItemClick,
  isDrawerOpen,
  setIsDrawerOpen,
}) => {
  const drawerOpenWidth = "18rem";
  const drawerCloseWidth = "0rem";

  return (
    <>
      <motion.div
        className="hidden md:block"
        style={{
          position: "fixed",
          top: 56,
          left: 0,
          height: "calc(100vh - 56px)",
          backgroundColor: "#f4f9fd",
          overflowX: "hidden",
          overflowY: "hidden",
          paddingTop: "4px",
          zIndex: 1200,
          boxShadow: isDrawerOpen ? "2px 0 6px rgba(0,0,0,0.08)" : "none",
        }}
        animate={{
          width: isDrawerOpen ? drawerOpenWidth : drawerCloseWidth,
        }}
        transition={{ duration: 0.25 }}
      >
        <MenuList onClick={handleMenuItemClick} isDrawerOpen={isDrawerOpen} />
      </motion.div>

      <motion.button
        type="button"
        className="hidden md:flex items-center justify-center"
        onClick={() => setIsDrawerOpen((prev) => !prev)}
        style={{
          position: "fixed",
          top: "50%",
          transform: "translateY(-50%)",
          width: "26px",
          height: "56px",
          backgroundColor: "#ffffff",
          borderRadius: "0 6px 6px 0",
          boxShadow: "2px 2px 6px rgba(0,0,0,0.15)",
          zIndex: 1250,
          cursor: "pointer",
          border: "none",
        }}
        animate={{
          left: isDrawerOpen ? drawerOpenWidth : drawerCloseWidth,
        }}
        transition={{ duration: 0.25 }}
      >
        {isDrawerOpen ? (
          <ChevronLeft fontSize="small" />
        ) : (
          <ChevronRight fontSize="small" />
        )}
      </motion.button>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              backgroundColor: "#f4f9fd",
              overflowX: "hidden",
              zIndex: 60,
            }}
            initial={{ width: 0 }}
            animate={{ width: drawerOpenWidth }}
            exit={{ width: 0 }}
            transition={{ duration: 0.2 }}
          >
            <Toolbar>
              <IconButton onClick={handleDrawerToggle} sx={{ marginLeft: "auto" }}>
                <FaTimes />
              </IconButton>
            </Toolbar>
            <MenuList onClick={handleMenuItemClick} isDrawerOpen />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

DrawerContent.propTypes = {
  mobileOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  handleMenuItemClick: PropTypes.func.isRequired,
  isDrawerOpen: PropTypes.bool.isRequired,
  setIsDrawerOpen: PropTypes.func.isRequired,
};

export default DrawerContent;
